import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['bgColorContainer']

  toggleLoginBgColorInput (e) {
    this.bgColorContainerTarget.classList.toggle('hidden')
  }
}
